{
  "main": {
    "title": "Weight and Balance",
    "nazaj": "Back"
  },
  "labelswb": {
    "isci": "Search / select aircraft",
    "izberi": "select",
    "odstrani": "remove",
    "izbrano": "selected",
    "neObstaja": "the searched aircraft is not among the aircraft",
    "praznaLista": "no aircraft to display"
  },
  "tekstwb": {
    "opozorilo": "Aircraft {plovilo} has no W&B parameters configured!",
    "opozorilo_podrobno": " Please inform the administrator of the aircraft registration so that the necessary parameters can be added."
  },
  "grafwb": {
    "opozorilo": "Aircraft {plovilo} does not have the wgt1-5 parameters configured to display the W&B chart!",
    "opozorilo_podrobno": " Notify the administrator of the aircraft registration so that they can add the required parameters."
  },
  "obrazec": {
    "labels": {
      "tezaLetalo": "Aircraft (empty) weight",
      "izpisTeze": "Weight ",
      "izpisMomenta": "Moment",
      "pilot": "Pilot and front seat",
      "sopotniki": "Passengers",
      "gorivo": "Fuel",
      "ptrljaga": "Baggage",
      "sTeza": "Total weight",
      "sMoment": "Total moment",
      "sMasa": "Total mass",
      "maksimalno": "Maximum:",
      "kalkulacija": "Calculation"
    }
  }
}
